module.exports = __webpack_public_path__ + "static/media/Alesis-S4-Plus-FatSynSlap-C2.346af258.wav";